import apiClient from './apiClient';

/**
 * Company API Service
 * Handles company creation, updates, and retrieval
 */
class CompanyService {
  
  /**
   * Check if current user has a company
   */
  async checkUserHasCompany() {
    try {
      const response = await apiClient.get('/companies/check');
      return response.data;
    } catch (error) {
      console.error('CompanyService.checkUserHasCompany error:', error);
      throw error;
    }
  }

  /**
   * Get current user's company with statistics
   */
  async getCurrentCompany() {
    try {
      const response = await apiClient.get('/companies/me');
      return response.data;
    } catch (error) {
      console.error('CompanyService.getCurrentCompany error:', error);
      throw error;
    }
  }

  /**
   * Create a new company
   */
  async createCompany(companyData) {
    try {
      const response = await apiClient.post('/companies', companyData);
      return response.data;
    } catch (error) {
      console.error('CompanyService.createCompany error:', error);
      throw error;
    }
  }

  /**
   * Update current user's company
   */
  async updateCompany(updateData) {
    try {
      const response = await apiClient.put('/companies/me', updateData);
      return response.data;
    } catch (error) {
      console.error('CompanyService.updateCompany error:', error);
      throw error;
    }
  }

  /**
   * Get business type options for forms (public endpoint)
   */
  async getBusinessTypes() {
    try {
      const response = await apiClient.get('/public/company-options/business-types');
      return response.data;
    } catch (error) {
      console.error('CompanyService.getBusinessTypes error:', error);
      throw error;
    }
  }

  /**
   * Get accounting method options for forms (public endpoint)
   */
  async getAccountingMethods() {
    try {
      const response = await apiClient.get('/public/company-options/accounting-methods');
      return response.data;
    } catch (error) {
      console.error('CompanyService.getAccountingMethods error:', error);
      throw error;
    }
  }
}

const companyService = new CompanyService();
export default companyService;